import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var CursorIcon = createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M17.85,9.29,5.34,5.12a.61.61,0,0,0-.77.77L8.74,18.4a.61.61,0,0,0,1,.24l2.44-2.45,3.37,3.36a.6.6,0,0,0,.86,0L19,17a.6.6,0,0,0,0-.86l-3.37-3.36,2.45-2.45A.61.61,0,0,0,17.85,9.29Z"
}), 'CursorIcon');